import { useEffect, useState } from 'react';

export const useGetTableContainerHeight = () => {
  const [containerHeight, setContainerHeight] = useState(
    window.innerHeight - 130
  );

  useEffect(() => {
    const updateContainerHeight = () => {
      setContainerHeight(window.innerHeight - 130);
    };

    updateContainerHeight();

    window.addEventListener('resize', updateContainerHeight);

    return () => window.removeEventListener('resize', updateContainerHeight);
  }, []);

  return containerHeight;
};
